















import { Component, Vue } from "vue-property-decorator";
import evaluation from "./EvaluationOfReply/evaluation.vue";
import reply from "./EvaluationOfReply/reply.vue";
@Component({
  components: {
    evaluation,
    reply,
  },
})
export default class Home extends Vue {
  public active = 0; // 初始默认
  public tabArr = ["evaluation", "reply"];
  public tabCom = "evaluation";
  public tabs = [
    {
      name: "我评价的",
    },
    {
      name: "我回复的",
    },
  ];
  public tabsSkip(index) {
    this.active = index;
    this.tabCom = this.tabArr[this.active];
  }
}
